export enum Sides {
  down= 0,
  left= -30,
  right= -60,
  up = -90
}